jQuery(function ($) {
	const notificationsForm = $('#notification-form');

	if (notificationsForm) {
		$(document).ready(function () {
			notificationsForm.on('submit', function (e) {
				let form = $(this);
				e.preventDefault();

				let keywords = $('#keywords-data').val();
				if (keywords === '') {
					$('#keywordsError').show();
				} else {
					$('#keywordsError').hide();

					$.ajax({
						url: $(this).attr('action'),
						type: 'POST',
						data: $(this).serialize(),
						success: function (data) {
							$('.js-saved-notifications').html(data);

							form[0].reset();
						},
						error: function (jXHR, textStatus, errorThrown) {
							alert(errorThrown);
						}
					});
				}
			});
		});
	}

	let deleteButtons = $('.notification-delete-button');
	if (deleteButtons) {
		$(document).on('click', '.notification-delete-button', function (e) {
			e.preventDefault();
			console.log($(this).attr('data-id'));

			$.ajax({
				url: $(this).attr('data-href'),
				type: 'POST',
				data: {'ID': $(this).attr('data-id')},
				success: function (data) {
					$('.js-saved-notifications').html(data);
				},
				error: function (jXHR, textStatus, errorThrown) {
					alert(errorThrown);
				}
			});
		});
	}
});


